import Vue from 'vue';
import router from '../../router';
import docCookies from './cookies';
import MD5 from './md5';
import SecureLS from 'secure-ls';
import store from '../../store';
import axios from 'axios';
import parsePhoneNumber from 'libphonenumber-js';
import isValidPhoneNumber from 'libphonenumber-js';
import parseMobile from 'libphonenumber-js/mobile';

// 七牛上传图片路径
const QN_UPLOAD_URL = 'https://upload-z2.qiniup.com/';
// 七牛获取图片前缀
let QN_URL_BASE = 'http://trashfiles.chehuijia.com.cn/';
// 默认图片
//const DEFAULT_IMAGE = 'http://publicfiles.chehuijia.com.cn//UploadFile/Commons/Public/Images/450x300.png';
// 默认图片方形
//const DEFAULT_IMAGE_square = 'http://publicfiles.chehuijia.com.cn//UploadFile/Commons/Public/Images/200x200.png';
const DEFAULT_IMAGE = '/img/icons/450x300.png';
const DEFAULT_IMAGE_square = '/img/icons/200x200.png';

// 项目基础路径
let serverRoot = 'https://localhost:44372';
// let serverRoot = 'http://dev.entp.chehuijia.com.cn'
let BASE_URL = serverRoot + '/api';

// 聊天页基础路径 本地环境
let CHAT_BASE_URL = 'https://localhost:44329'; //'http://192.168.0.244:3844';
// let CHAT_BASE_URL = 'http://dev.csr.chehuijia.com.cn/';
//搜索引擎基础路径 本地环境
let SEARCH_URL = 'https://localhost:44373';
// let SEARCH_URL = 'http://dev.common.api.chehuijia.com.cn/';

//是否是车回佳桌面应用
let CHJWinApp = navigator.userAgent === 'CHJWinApp/1.x';
//线上环境
if (process.env.NODE_ENV === 'production') {
    BASE_URL = '/api';
    //测试环境
    if (window.location.href.indexOf('dev') != -1 || window.location.href.indexOf('192.168') != -1) {
        serverRoot = 'http://192.168.0.244:3835';
        CHAT_BASE_URL = 'http://192.168.0.244:3845';
        SEARCH_URL = 'http://192.168.0.244:3950';
    } else {
        //生产环境
        if (window.location.href.indexOf('https') != -1) serverRoot = 'http://entp.chehuijia.com.cn';
        else serverRoot = 'http://entp.chehuijia.com.cn';
        CHAT_BASE_URL = 'http://csr.chehuijia.com.cn';
        SEARCH_URL = 'https://common.api.chehuijia.com.cn';
        QN_URL_BASE = 'http://publicfiles.chehuijia.com.cn/';
    }
}

//为了收集请求
const CancelToken = axios.CancelToken;
// axios Get
async function axiosGet(params) {
    let loading = null;
    if (!params.hideLoading) {
        loading = Vue.prototype.$loading({
            lock: true,
            target: document.querySelector('.business-content'),
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
    }
    let path = window.location.href;
    if (path.indexOf('?') != -1) {
        //判断是否存在参数
        path = path.substring(0, path.indexOf('?')); //去除参数
    }
    let token = getLocalStorage('userMsg') ? getLocalStorage('userMsg').Token : '';
    let url = '';
    if (params.eipApi) {
        url = CHAT_BASE_URL + params.url.replace('/admin', '/api');
    } else if (params.search) {
        url = SEARCH_URL + params.url.replace('/search', '/api');
    } else {
        url = params.url;
    }
    return new Promise((resolve, reject) => {
        Vue.prototype.axios
            .get(url, {
                responseType: params.QRImg ? 'arraybuffer' : null,
                params: params.data ? params.data : null,
                headers: {
                    'access-key': token,
                    //'timestamp': timestamp,
                    reqApp: 'yqgPC',
                    source: path
                },
                // cancelToken: params.cancelToken,
                cancelToken: params.cancelToken
                    ? params.cancelToken
                    : new CancelToken(c => {
                          //cancelToken函数返回中将所有请求添加到state中去
                          //切换路由时取消之前所有尚未返回结果的请求beforeEach钩子函数
                          store.commit('addCancelToken', c);
                      })
            })
            .then(response => {
                let _data = response.data;
                // 例外
                if (params.exception) {
                    resolve(_data);
                    closeLoading(loading);
                    return;
                }
                if (response.status == 200 && (_data.errcode == 0 || _data.errcode == 200 || _data.errcode == 201 || _data.code == 0)) {
                    closeLoading(loading);
                    resolve(_data);
                } else {
                    if (_data.errcode == 402) {
                        clearLoginedData();
                        clearCookie('Token');
                        router.push('/login');
                    }
                    if (_data.errcode == 500 || _data.errcode == 401) errorMsg(_data.errmsg);
                    reject(_data);
                    closeLoading(loading);
                }
            })
            .catch(error => {
                if (error.message) {
                    // errorMsg(error.message);
                }
                params.error && params.error();
                reject(error);
                closeLoading(loading);
            });
    });
}
// axios Post
async function axiosPost(params) {
    let loading;
    if (!params.hideLoading) {
        loading = Vue.prototype.$loading({
            lock: true,
            target: document.querySelector('.business-content'),
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
    }
    let path = window.location.href;
    if (path.indexOf('?') != -1) {
        //判断是否存在参数
        path = path.substring(0, path.indexOf('?')); //去除参数
    }
    let token = getLocalStorage('userMsg') ? getLocalStorage('userMsg').Token : '';
    let url = '';
    if (params.eipApi) {
        url = CHAT_BASE_URL + params.url.replace('/admin', '/api');
    } else if (params.search) {
        url = SEARCH_URL + params.url.replace('/search', '/api');
    } else {
        url = params.url;
    }
    return new Promise((resolve, reject) => {
        Vue.prototype
            .axios({
                method: 'post',
                url: url,
                responseType: params.QRImg ? 'arraybuffer' : null,
                data: params.data ? params.data : null,
                headers: {
                    'access-key': token,
                    // 'timestamp': timestamp,
                    reqApp: 'yqgPC',
                    source: path
                },
                // cancelToken: params.cancelToken
                cancelToken: params.cancelToken
                    ? params.cancelToken
                    : new CancelToken(c => {
                          store.commit('addCancelToken', c);
                      })
            })
            .then(response => {
                let _data = response.data;
                if (typeof response == 'string') {
                    return;
                }
                // 例外
                if (params.exception) {
                    resolve(_data);
                    closeLoading(loading);
                    return;
                }
                if (response.status == 200 && (_data.errcode == 0 || _data.errcode == 200 || _data.errcode == 201)) {
                    resolve(_data);
                    closeLoading(loading);
                } else {
                    if (_data.errcode == 402) {
                        clearLoginedData();
                        router.push('/login');
                    }
                    if (_data.errcode == 500 || _data.errcode == 401) errorMsg(_data.errmsg);
                    reject(_data);
                    closeLoading(loading);
                }
            })
            .catch(error => {
                if (error.message) {
                    // errorMsg(error.message);
                }
                reject(error);
                closeLoading(loading);
            });
    });
}
//关闭请求loading
function closeLoading(loading) {
    if (loading) {
        loading.close();
    }
}
//清除登录失效后，用户的缓存数据
function clearLoginedData() {
    let dialogIM = document.querySelectorAll('.layui-layer');
    if (dialogIM) for (let i = 0; i < dialogIM.length; i++) document.body.removeChild(dialogIM[i]);

    //一次清空所有
    clearAllLocalStorage();
    clearCookie('Token');
}
// 导出文件 最终版
function exportFile(options) {
    return new Promise(resolve => {
        let token = getLocalStorage('userMsg') ? getLocalStorage('userMsg').Token : '';
        Vue.prototype.axios
            .get(options.url, {
                responseType: 'blob',
                params: options.data,
                headers: {
                    'access-key': token,
                    reqApp: 'yqgPC'
                }
            })
            .then(res => {
                //接口返回异常信息时处理
                if (res.data.type == 'text/plain') {
                    const blob = new Blob([res.data], { type: 'text/plain' });
                    readBlobAsText(blob);
                    return;
                }
                let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                //获取heads中的filename文件名
                // let temp = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
                let temp = res.headers['content-disposition'].split(';')[2].split("filename*=UTF-8''")[1];
                let fileName = decodeURIComponent(temp);

                const blobUrl = window.URL.createObjectURL(blob);
                let _a = document.createElement('a');
                _a.setAttribute('href', blobUrl);
                _a.setAttribute('target', '_blank');
                _a.setAttribute('id', 'exportUrl');
                _a.setAttribute('download', fileName);
                document.body.appendChild(_a);
                let url = document.getElementById('exportUrl');
                url.style.display = 'none';
                url.click();
                url.parentNode.removeChild(url);
                resolve();
            });
    });
}
function exportFile_post(options) {
    let loading;
    if (!options.hideLoading) {
        loading = Vue.prototype.$loading({
            lock: true,
            target: document.querySelector('.business-content'),
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
    }
    return new Promise(resolve => {
        let token = getLocalStorage('userMsg') ? getLocalStorage('userMsg').Token : '';
        Vue.prototype
            .axios({
                method: 'post',
                url: options.url,
                responseType: 'blob',
                data: options.data,
                headers: {
                    'access-key': token,
                    reqApp: 'yqgPC'
                }
            })
            .then(res => {
                //接口返回异常信息时处理
                if (res.data.type == 'text/plain') {
                    const blob = new Blob([res.data], { type: 'text/plain' });
                    readBlobAsText(blob);
                    return;
                }
                let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                //获取heads中的filename文件名
                let temp = res.headers['content-disposition'].split(';')[2].split("filename*=UTF-8''")[1];
                let fileName = decodeURIComponent(temp);

                const blobUrl = window.URL.createObjectURL(blob);
                let _a = document.createElement('a');
                _a.setAttribute('href', blobUrl);
                _a.setAttribute('target', '_blank');
                _a.setAttribute('id', 'exportUrl');
                _a.setAttribute('download', fileName);
                document.body.appendChild(_a);
                let url = document.getElementById('exportUrl');
                url.style.display = 'none';
                url.click();
                url.parentNode.removeChild(url);
                resolve();
            })
            .finally(() => {
                closeLoading(loading);
            });
    });
}
//使用FileReader来读取Blob内容，并将其转换成文本
function readBlobAsText(blob) {
    const reader = new FileReader();
    reader.onload = e => {
        errorMsg(e.target.result);
    };
    reader.readAsText(blob); // 使用readAsText方法读取Blob为文本
}
// 成功弹窗
function successMsg(text) {
    Vue.prototype.$message({
        message: text,
        type: 'success'
    });
}
// 警告弹窗
function warningMsg(text) {
    Vue.prototype.$message({
        message: text,
        type: 'warning'
    });
}
// 错误弹窗
function errorMsg(text) {
    Vue.prototype.$message.error(text);
}
// Confirm弹窗
function elConfirm(params) {
    Vue.prototype
        .$confirm(params.content, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
        .then(() => {
            params.confirm();
            if (!params.noMsg) {
                successMsg(params.confirmMsg ? params.confirmMsg : '删除成功！');
            }
        })
        .catch(err => {
            params.cancel && params.cancel();
        });
}
// 存储LocalStorage
function setSessionStorage(key, obj) {
    // let ls = new SecureLS();
    key = `entp_${key}`; //加entp用于区分其他系统
    let str = JSON.stringify(obj);
    sessionStorage.setItem(key, str);
}
// 读取SessionStorage
function getSessionStorage(key) {
    key = `entp_${key}`;
    let str = sessionStorage.getItem(key);
    let obj = JSON.parse(str);
    return obj;
}
// 删除SessionStorage
function clearSessionStorage(key) {
    key = `entp_${key}`;
    sessionStorage.removeItem(key);
}
// 存储LocalStorage
function setLocalStorage(key, obj) {
    let ls = new SecureLS();
    key = `entp_${key}`;
    let str = JSON.stringify(obj);
    // localStorage.setItem(key, str)
    ls.set(key, str);
}
// 读取LocalStorage
function getLocalStorage(key) {
    try {
        let ls = new SecureLS();
        key = `entp_${key}`;
        // let str = localStorage.getItem(key)
        let str = ls.get(key);
        if (str) {
            let obj = JSON.parse(str);
            return obj;
        } else return null;
    } catch (error) {
        return null;
    }
}
// 删除LocalStorage
function clearLocalStorage(key) {
    key = `entp_${key}`;
    // localStorage.removeItem(key)
    let ls = new SecureLS();
    ls.remove(key);
}

function clearAllLocalStorage() {
    let ls = new SecureLS();
    ls.removeAll();
}

// 图片上传前校验
function uploadCheck(file) {
    const isJPG = file.type === 'image/jpeg';
    const isGIF = file.type === 'image/gif';
    const isPNG = file.type === 'image/png';
    const isBMP = file.type === 'image/bmp';
    //改成10M
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
    }
    if (!isLt10M) {
        this.$util.warningMsg('上传图片大小不能超过 10MB!');
    }
    return (isJPG || isBMP || isGIF || isPNG) && isLt10M;
}
// 获取公共配置
function getConfigData(names) {
    return new Promise(resolve => {
        axiosGet({
            url: `/api/TypeConfigs/GetTypeConfig`,
            data: {
                names: names
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
// 校验电话号码
let checkPhone = (rule, value, callback) => {
    const reg = /^$|^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/;
    if (reg.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的手机号或固话'));
    }
};
//校验手机号或固话，支持境外电话验证
let validatePhoneNumber = (rule, value, callback) => {
    // const phone = parsePhoneNumber(value, '国际格式'); // 例如 'CN', 'US' 等
    // const phone = parsePhoneNumber(value);
    //libphonenumber-js 验证需要国际区号+号码，所以国内的电话就用原来的正则验证验证不通过再用libphonenumber
    let isMob = /^1[3-9]\d{9}$/;
    let isPhone = /^((0\d{2,3})-)?(\d{7,8})$/;
    // const reg = /^$|^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/;
    if (isPhone.test(value) || isMob.test(value)) {
        callback();
    } else if (isValidPhoneNumber(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的手机号或固话'));
    }
};
//校验是否正确的手机号码
let validateMobile = (rule, value, callback) => {
    let isMob = /^1[3-9]\d{9}$/;
    let isPhone = /^((0\d{2,3})-)?(\d{7,8})$/;
    if (isMob.test(value)) {
        callback();
    } else if (isPhone.test(value)) {
        return callback(new Error('请输入正确的手机号'));
    } else if (isValidPhoneNumber(value)) {
        // 而使用专门针对手机的数据包，同样可以准确判断为移动电话。
        if (parseMobile(value).getType() === 'MOBILE') callback();
        else return callback(new Error('请输入正确的手机号'));
    } else {
        return callback(new Error('请输入正确的手机号'));
    }
};
//校验手机号并返回手机所属国家，如果手机验证不通过返回''
let validateMobileCountry = value => {
    let isMob = /^1[3-9]\d{9}$/;
    if (isMob.test(value)) {
        return 'CN';
    } else if (isValidPhoneNumber(value)) {
        // 而使用专门针对手机的数据包，同样可以准确判断为移动电话。
        if (parseMobile(value).getType() !== 'MOBILE') {
            return '';
        }
        const phone = parsePhoneNumber(value);
        if (phone) {
            return phone.country;
        }
    } else {
        return '';
    }
};
// 校验 邮箱
let checkEmail = (rule, value, callback) => {
    const reg = /^$|^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
    if (reg.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的邮箱'));
    }
};
// 校验非负数
let checkPositive = (rule, value, callback) => {
    if (Number(value) >= 0 || !value) {
        callback();
    } else {
        return callback(new Error('请输入大于0的数字'));
    }
};
let checkInt = (rule, value, callback) => {
    const r = /^\+?[1-9][0-9]*$/;
    if (r.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正整数'));
    }
};

// 校验地址
const checkAddress = (rule, value, callback) => {
    if (!value[0]) {
        return callback(new Error('请选择地址'));
    }
};

// 参数转换
function parseParam(params) {
    const sdata = [];
    for (let attr in params) {
        sdata.push(attr + '=' + filter(params[attr]));
    }
    return sdata.join('&');
}

function filter(str) {
    // 特殊字符转义
    str += ''; // 隐式转换
    str = str.replace(/%/g, '%25');
    str = str.replace(/\+/g, '%2B');
    str = str.replace(/ /g, '%20');
    str = str.replace(/\//g, '%2F');
    str = str.replace(/\?/g, '%3F');
    str = str.replace(/&/g, '%26');
    str = str.replace(/#/g, '%23');
    return str;
}
// 获取当前日期
function getNowFormatDate() {
    let date = new Date();
    let seperator1 = '-';
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}
//获取当前时间
function getNowFormatTime() {
    let date = new Date();
    let seperator2 = ':';
    let strHours = date.getHours();
    let strMinutes = date.getMinutes();
    if (strHours >= 0 && strHours <= 9) {
        strHours = '0' + strHours;
    }
    if (strMinutes >= 0 && strMinutes <= 9) {
        strMinutes = '0' + strMinutes;
    }
    let currentdate = strHours + seperator2 + strMinutes;
    return currentdate;
}
//时间戳转换
function formatDate(value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? '0' + MM : MM;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let m = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

function formatDateV2(value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? '0' + MM : MM;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let m = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    return y + '/' + MM + '/' + d;
}

function formatDateV3(value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? '0' + MM : MM;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let m = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    return y + '-' + MM + '-' + d;
}

//两个日期相差天数
function dateDifference(sDate1, sDate2) {
    let dateSpan, iDays;
    sDate1 = Date.parse(sDate1);
    sDate2 = Date.parse(sDate2);
    dateSpan = sDate2 - sDate1;
    dateSpan = Math.abs(dateSpan);
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
    return iDays;
}
// 上传图片时获取token
function geToken(fileDomain, fileType, isPrivate) {
    return new Promise((resolve, reject) => {
        axiosGet({
            url: '/admin/Common/GetUploadToken',
            data: {
                fileDomain: fileDomain, // 表名
                fileType: fileType, // 文件类型
                isPrivate: isPrivate //是否私有
            },
            eipApi: true
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {});
    });
}
//
function getUserIMData() {
    return new Promise((resolve, reject) => {
        let userMsg = getLocalStorage('userMsg');
        axiosGet({
            url: '/admin/EntpIMCenter/GetEntpUserAndServiceList',
            data: {
                uid: userMsg.EmployeeId,
                entpId: userMsg.EntpId
            },
            hideLoading: true,
            eipApi: true
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {});
    });
}
// 清除ele 表单验证
function clearValidate(that, formName) {
    that.$refs[formName].clearValidate();
}
// 再次购买
function buyAgain(id) {
    axiosPost({
        url: '/api/MallShoppingCart/AddShoppingCartSaleOrderGoods',
        data: {
            OrderId: id,
            userId: getLocalStorage('userMsg').EmployeeId
        }
    }).then(() => {
        successMsg('订单商品已加入购物车');
    });
}
// 跳转消息详情
function gotoMessageDetails(that, item) {
    that.$router.push(item.RedirectUrl);
}
// 获取首页通知
function getMessage() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/Notification/GetHomePageNotification',
            data: {
                UId: getLocalStorage('userMsg').EmployeeId
            },
            hideLoading: true
        }).then(res => {
            let data = res.data;
            resolve(data);
        });
    });
}
// 商品加入购物车
function goodsJoinCar(GoodsId) {
    return new Promise((resolve, reject) => {
        axiosPost({
            url: '/api/MallShoppingCart/AddShoppingCartGoods',
            data: {
                UserId: getLocalStorage('userMsg').EmployeeId,
                GoodsIds: GoodsId
            },
            hideLoading: true
        }).then(() => {
            successMsg('加入购物车成功');
            resolve();
        });
    });
}
// 套装加入购物车
function suitJoinCar(PmId) {
    return new Promise((resolve, reject) => {
        axiosPost({
            url: '/api/MallShoppingCart/AddShoppingCartPackageGoods',
            data: {
                UserId: getLocalStorage('userMsg').EmployeeId,
                PmId: PmId
            },
            hideLoading: true
        }).then(() => {
            resolve();
            successMsg('加入购物车成功');
        });
    });
}
// 数字转为3位浮点数
function num2Float(value) {
    return parseFloat(value).toFixed(2);
}
//获取某个日期的前多少天或后多少天
function getOtherDay(date, num) {
    let day = new Date(date);
    day.setDate(day.getDate() + num);
    // return day.getFullYear() + '-'+(day.getMonth()+1) + '-' + day.getDate()
    return day;
}
// 对象的深拷贝
function isObj(obj) {
    return (typeof obj === 'object' || typeof obj === 'function') && obj !== null;
}

function deepCopy(obj, hash = new WeakMap()) {
    if (hash.has(obj)) return hash.get(obj);
    let cloneObj = Array.isArray(obj) ? [] : {};
    hash.set(obj, cloneObj);
    for (let key in obj) {
        cloneObj[key] = isObj(obj[key]) ? deepCopy(obj[key], hash) : obj[key];
    }
    return cloneObj;
}

// 获取权限树
function getTreeForDT() {
    return new Promise((resolve, reject) => {
        let root = getLocalStorage('root');
        if (root) {
            resolve();
        } else {
            if (getLocalStorage('userMsg')) {
                axiosGet({
                    url: '/api/Permission/GetUserModules'
                }).then(res => {
                    if (res.data) {
                        let jsonData = JSON.stringify(res.data);
                        let md5 = MD5.hex_md5(jsonData);
                        if (!root || root.hex != md5) {
                            saveRoot(res.data);
                            resolve();
                        }
                    }
                });
            }
        }
    });
}

// 获取权限树
function getTreeForTop() {
    return new Promise((resolve, reject) => {
        let root = getLocalStorage('root');
        if (root) {
            resolve();
        } else {
            if (getLocalStorage('userMsg')) {
                axiosGet({
                    url: '/api/Permission/GetUserModulesForTopNav'
                }).then(res => {
                    if (res.data) {
                        let jsonData = JSON.stringify(res.data);
                        let md5 = MD5.hex_md5(jsonData);
                        if (!root || root.hex != md5) {
                            saveRoot(res.data);
                            resolve();
                        }
                    }
                });
            }
        }
    });
}

// 获取权限树
function getTree() {
    return new Promise((resolve, reject) => {
        let root = getLocalStorage('root');
        if (root) {
            resolve();
        } else {
            if (getLocalStorage('userMsg')) {
                axiosGet({
                    url: '/api/Permission/GetUserModulesForNav'
                }).then(res => {
                    if (res.data) {
                        let jsonData = JSON.stringify(res.data);
                        let md5 = MD5.hex_md5(jsonData);
                        if (!root || root.hex != md5) {
                            saveRoot(res.data);
                            resolve();
                        }
                    }
                });
            }
        }
    });
}
// 获取首页模块
function getHomeModules(data) {
    return new Promise((resolve, reject) => {
        if (!getLocalStorage('homeIcons')) {
            if (!data) {
                data = '1';
            }
            axiosGet({
                url: '/api/Permission/GetHomeModules?Type=' + data
            })
                .then(res => {
                    let data = res.data;
                    setLocalStorage('homeIcons', data);
                    resolve(data);
                })
                .catch(() => {});
        } else {
            resolve(getLocalStorage('homeIcons'));
        }
    });
}

// 获取联盟数据
function getUnionDatas(isClear) {
    if (isClear) clearLocalStorage('unionIcons');
    return new Promise((resolve, reject) => {
        if (!getLocalStorage('unionIcons')) {
            axiosGet({
                url: '/api/Permission/GetUnionDatas'
            })
                .then(res => {
                    let data = res.data;
                    setLocalStorage('unionIcons', data);
                    resolve(data);
                })
                .catch(() => {});
        } else {
            resolve(getLocalStorage('unionIcons'));
        }
    });
}

// 获取权限树
function getUnionTree() {
    return new Promise((resolve, reject) => {
        let currentUnion = getLocalStorage('currentUnion');
        if (currentUnion) {
            let root = getLocalStorage('root_' + currentUnion);
            if (root) {
                resolve();
            } else {
                if (getLocalStorage('userMsg')) {
                    axiosGet({
                        url: '/api/Permission/GetUserUnionModules',
                        data: {
                            unionId: currentUnion
                        }
                    }).then(res => {
                        if (res.data) {
                            let jsonData = JSON.stringify(res.data);
                            let md5 = MD5.hex_md5(jsonData);
                            if (!root || root.hex != md5) {
                                saveUnionRoot(res.data, currentUnion);
                                resolve();
                            }
                        }
                    });
                }
            }
        } else reject();
    });
}

function updateUnionRoot() {
    return new Promise((resolve, reject) => {
        let currentUnion = getLocalStorage('currentUnion');
        if (currentUnion) {
            if (getLocalStorage('userMsg')) {
                axiosGet({
                    url: '/api/Permission/GetUserUnionModules',
                    data: {
                        unionId: currentUnion
                    }
                }).then(res => {
                    if (res.data) {
                        saveUnionRoot(res.data, currentUnion);
                        resolve();
                    }
                });
            }
        } else reject();
    });
}

//更新企业系统设置的缓存
function updateEntpSysConfigCache() {
    return new Promise((resolve, reject) => {
        axiosPost({
            url: '/api/EntpInfoManagement/UpdateEntpSysConfigCache',
            hideLoading: true
        }).then(res => {
            if (res.data) {
                let userMsg = getLocalStorage('userMsg');
                userMsg.SysConfigs = res.data;
                setLocalStorage('userMsg', userMsg);
                resolve();
            }
        });
    });
}

//root_UnionId的权限存进缓存
function saveUnionRoot(data, unionId) {
    let _root = null;
    if (data) {
        let md5 = MD5.hex_md5(JSON.stringify(data)); //必须是字符串
        _root = {
            Item: {
                Name: '前端联盟自定义根节点',
                Code: 'ctn_union'
            },
            Children: data,
            hex: md5
        };
        clearLocalStorage('root_' + unionId);
        setLocalStorage('root_' + unionId, _root);
    }
}

function updateRoot() {
    return new Promise((resolve, reject) => {
        let root = getLocalStorage('root');
        axiosGet({
            url: '/api/Permission/GetUserModulesForUpdateRoot'
        }).then(res => {
            clearLocalStorage('homeIcons');
            getHomeModules('2');
            if (res.data) {
                // let jsonData = JSON.stringify(res.data);
                // let md5 = MD5.hex_md5(jsonData);
                // if (!root || root.hex != md5) {
                //     saveRoot(res.data);
                //     resolve();
                // }
                saveRoot(res.data);
                resolve();
            }
        });
    });
}
//root存进缓存
function saveRoot(data) {
    let _root = null;
    if (data) {
        let md5 = MD5.hex_md5(JSON.stringify(data)); //必须是字符串
        _root = {
            Item: {
                Name: '前端自定义根节点',
                Code: 'ctn'
            },
            Children: data,
            hex: md5
        };
        clearLocalStorage('root');
        setLocalStorage('root', _root);
    }
}
// 根据名称获取该节点
function getNode(Code, level) {
    let tree = getLocalStorage('root');
    if (!Code) {
        return tree;
    }
    let node = mapTree(tree, Code);
    if (node) {
        return node;
    }
}

function getUnionNode(Code, level) {
    let currentUnion = getLocalStorage('currentUnion');
    if (currentUnion) {
        let tree = getLocalStorage('root_' + currentUnion);
        if (!Code) {
            return tree;
        }
        let node = mapTree(tree, Code);
        if (node) {
            return node;
        }
    }
}
//获取横向导航的节点
function getAcrossNavNode(Code, level) {
    let tree = getLocalStorage('root');
    if (!Code) {
        return tree;
    }
    let node = mapTree(tree, Code);
    if (node) {
        if (node.Children[0]) {
            if (level == 1) {
                for (let i = 0; i < node.Children.length; i++) {
                    node.Children[i].Item.originUrl = node.Children[i].Item.Url;
                    if (node.Children[i].Children[0] && node.Children[i].Children[0].Item.Url) {
                        node.Children[i].Item.Url = node.Children[i].Children[0].Item.Url;
                    }
                }
            }
        }
        let _menu = [];
        if (node.Children[0]) {
            for (let j = 0; j < node.Children.length; j++) {
                _menu.push(node.Children[j].Item);
            }
        } else {
            _menu = node;
        }
        return _menu;
    }
}

function getAcrossUnionNavNode(Code, level) {
    let currentUnion = getLocalStorage('currentUnion');
    if (currentUnion) {
        let tree = getLocalStorage('root_' + currentUnion);
        if (!Code) {
            return tree;
        }
        let node = mapTree(tree, Code);
        if (node) {
            if (node.Children[0]) {
                if (level == 1) {
                    for (let i = 0; i < node.Children.length; i++) {
                        node.Children[i].Item.originUrl = node.Children[i].Item.Url;
                        if (node.Children[i].Children[0] && node.Children[i].Children[0].Item.Url) {
                            node.Children[i].Item.Url = node.Children[i].Children[0].Item.Url;
                        }
                    }
                }
            }
            let _menu = [];
            if (node.Children[0]) {
                for (let j = 0; j < node.Children.length; j++) {
                    _menu.push(node.Children[j].Item);
                }
            } else {
                _menu = node;
            }
            return _menu;
        }
    }
}
// 遍历树
function mapTree(node, Code) {
    let result = null;
    if (!node) {
        return null;
    }
    if (node.Item.Code == Code) {
        result = node;
    } else {
        if (node.Children[0]) {
            for (let i = 0; i < node.Children.length; i++) {
                if (result) {
                    break;
                }
                if (node.Children[i].Item.Code == Code) {
                    result = node.Children[i];
                    break;
                } else {
                    result = mapTree(node.Children[i], Code);
                }
            }
        }
    }
    return result;
}
// 获取一企管权限
function getPermission(node) {
    let _permission = getNode(node) ? getNode(node).Item.Elements : [];
    _permission.sort((a, b) => {
        return a.Sort - b.Sort;
    });
    let result = {};
    for (let i = 0; i < _permission.length; i++) {
        result[_permission[i].DomId] = _permission[i].Name;
    }
    return result;
}
// 获取联盟
function getUnionPermission(node) {
    let _permission = getUnionNode(node) ? getUnionNode(node).Item.Elements : [];
    _permission.sort((a, b) => {
        return a.Sort - b.Sort;
    });
    let result = {};
    for (let i = 0; i < _permission.length; i++) {
        result[_permission[i].DomId] = _permission[i].Name;
    }
    return result;
}
// 获取浏览器版本
function getExplorerInfo() {
    let explorer = window.navigator.userAgent.toLowerCase();
    //ie
    if (explorer.indexOf('msie') >= 0) {
        let ver = explorer.match(/msie ([\d.]+)/)[1];
        return {
            type: 'IE',
            version: ver
        };
    }
    //firefox
    else if (explorer.indexOf('firefox') >= 0) {
        let ver = explorer.match(/firefox\/([\d.]+)/)[1];
        return {
            type: 'Firefox',
            version: ver
        };
    }
    //Chrome
    else if (explorer.indexOf('chrome') >= 0) {
        let ver = explorer.match(/chrome\/([\d.]+)/)[1];
        return {
            type: 'Chrome',
            version: ver
        };
    }
    //Opera
    else if (explorer.indexOf('opera') >= 0) {
        let ver = explorer.match(/opera.([\d.]+)/)[1];
        return {
            type: 'Opera',
            version: ver
        };
    }
    //Safari
    else if (explorer.indexOf('Safari') >= 0) {
        let ver = explorer.match(/version\/([\d.]+)/)[1];
        return {
            type: 'Safari',
            version: ver
        };
    }
}
// 提交浏览记录
function browseRecord(ops, that, ObjId) {
    if (process.env.NODE_ENV === 'production') {
        let sys = getExplorerInfo();
        let Browser = sys.type;
        let BrowserVer = sys.version;
        if (ops == 1) {
            that.recordStart = timeForRecord();
        } else if (ops == 2) {
            let _router = that.$route;
            let currentPage = _router.path;
            let prevPage = _router.params.prevPath;
            let recordStart = that.recordStart;
            let recordEnd = timeForRecord();
            let userMsg = getLocalStorage('userMsg');
            axiosPost({
                url: '/search/CollectionDatas/SubmitBrowseData',
                data: {
                    ObjId: ObjId,
                    UId: userMsg ? userMsg.EmployeeId : '',
                    RefererUrl: prevPage,
                    Url: currentPage,
                    PlaformType: 'entp_pc_client',
                    Browser: Browser,
                    BrowserVer: BrowserVer,
                    UType: '1',
                    StartBrowseTime: recordStart,
                    EndBrowseTime: recordEnd
                },
                hideLoading: true,
                search: true
            })
                .then(() => {})
                .catch(e => {});
        }
    }
}

function timeForRecord() {
    let date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':');
}
const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n;
};

// cookie 相关
function setCookie(name, value, expires) {
    name = `entp_${name}`;
    let _value = encodeURIComponent(value);
    docCookies.setItem(name, _value, expires);
}

function getCookie(key) {
    key = `entp_${key}`;
    let _value = docCookies.getItem(key);
    if (_value) {
        _value = decodeURIComponent(docCookies.getItem(key));
    } else {
        _value = null;
    }
    return _value;
}

function clearCookie(key) {
    key = `entp_${key}`;
    docCookies.removeItem(key, '/');
}

// 设置页面enter
function setEnterEvent(that, fullPath) {
    document.onkeydown = event => {
        let isDialog = document.querySelector('.v-modal');
        let layui = document.querySelectorAll('.layui-layer');
        //当有弹出框或是layim弹出框时不请求
        if (fullPath == that.$route.fullPath && !isDialog && layui.length <= 1) {
            if (event && event.keyCode == 13) {
                if (that.getTableData) {
                    that.getTableData();
                }
            } else if (event.keyCode === 37) {
                // Previous page
                if (that.searchData.page > 1) {
                    that.searchData.page -= 1;
                    that.getTableData();
                }
            } else if (event.keyCode === 39) {
                // Next page
                if (that.searchData.page < Math.ceil(that.tableDataLength / that.searchData.limit)) {
                    that.searchData.page += 1;
                    that.getTableData();
                }
            }
        }
    };
}

function setEventForDialog(that, el) {
    //当el是div这类型无法聚焦的元素时，鼠标点击其input等可聚焦的子元素才能触发keydown
    el.addEventListener(
        'keydown',
        function (event) {
            if (event && event.keyCode == 13) {
                that.searchData.page = 1;
                if (that.getTableData) {
                    that.getTableData();
                }
            } else if (event.keyCode === 37) {
                // Previous page
                if (that.searchData.page > 1) {
                    that.searchData.page -= 1;
                    that.getTableData();
                }
            } else if (event.keyCode === 39) {
                // Next page
                if (that.searchData.page < Math.ceil(that.tableDataLength / that.searchData.limit)) {
                    that.searchData.page += 1;
                    that.getTableData();
                }
            }
        },
        false
    );
}

function removeEventForDialog(that, el) {
    el.addEventListener('keydown', function (event) {}, false);
}
/**
 * 页面跳转前提示
 * 使用setTimeout主要用于解决浏览器前进后退出现的的闪现，但是又引出了新的问题：beforeRouteLeave执行了两次，弹出两次弹框
 * 这里使用定义一个参数timer用于保存setTimeout定时器对象，只触发最后一个定时器，其他定时器清除
 * @param {boolean} timer 保存setTimeout定时器对象
 * next(false) 中断当前的导航。如果浏览器的 URL 改变了 (可能是用户手动或者浏览器后退按钮)，那么 URL 地址会重置到 from 路由对应的地址。
 */
let timer = null;

function confirmBeforeLeave(to, from, next, that) {
    next(false);
    if (that.needConfirm && that.type != 1) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            that.$confirm('<span style="color:red;font-size: 16px;">系统将不会保存您填写的信息，确定要跳转吗？</span>', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                closeOnClickModal: false,
                closeOnHashChange: false
            })
                .then(() => {
                    // 清除页面缓存
                    if (that.removePageChace) {
                        that.removePageChace();
                    }
                    //将离开页面需要注销的事件放到这里来，确认离开后再处理
                    if (that.handleKeyEvent) {
                        document.removeEventListener('keydown', that.handleKeyEvent);
                    }
                    let tablebody = document.querySelector('.elx-table--body-wrapper');
                    if (tablebody) tablebody.removeEventListener('click', this.clearActived, false);
                    next();
                })
                .catch(() => {
                    next(false);
                });
        }, 200);
    } else {
        // 清除页面缓存
        if (that.removePageChace) {
            that.removePageChace();
        }
        //将离开页面需要注销的事件放到这里来，确认离开后再处理
        if (that.handleKeyEvent) {
            document.removeEventListener('keydown', that.handleKeyEvent);
        }
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        if (tablebody) tablebody.removeEventListener('click', this.clearActived, false);
        next();
    }
}
// 两个数组去重合并
function uniqueArr(arr1, arr2) {
    //合并两个数组
    arr1.push(...arr2);
    //去重
    let obj = {};
    let result = [];
    for (let i = 0; i < arr1.length; i++) {
        if (typeof arr1[i] == 'object') {
            if (!obj[JSON.stringify(arr1[i])]) {
                obj[JSON.stringify(arr1[i])] = true;
            }
        } else if (typeof arr1[i] == 'string' || typeof arr1[i] == 'number') {
            obj[arr1[i]] = true;
        }
    }
    for (let key in obj) {
        result.push(JSON.parse(key));
    }
    return result;
}
//生成唯一id
function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function moneyToCapital(num) {
    let fuhao = '';
    let text = num + '';
    if (text.indexOf('-') > -1) {
        num = text.replace('-', '');
        fuhao = '负';
    }
    let money1 = new Number(num);
    let monee = Math.round(money1 * 100).toString(10);
    let leng = monee.length;
    let monval = '';
    for (let i = 0; i < leng; i++) {
        monval = monval + to_upper(monee.charAt(i)) + to_mon(leng - i - 1);
    }
    return fuhao + repace_acc(monval);
}
// 将数字转为大写的中文字
function to_upper(a) {
    switch (a) {
        case '0':
            return '零';
        case '1':
            return '壹';
        case '2':
            return '贰';
        case '3':
            return '叁';
        case '4':
            return '肆';
        case '5':
            return '伍';
        case '6':
            return '陆';
        case '7':
            return '柒';
        case '8':
            return '捌';
        case '9':
            return '玖';
        default:
            return '';
    }
}

function to_mon(a) {
    if (a > 10) {
        a = a - 8;
        return to_mon(a);
    }
    switch (a) {
        case 0:
            return '分';
        case 1:
            return '角';
        case 2:
            return '元';
        case 3:
            return '拾';
        case 4:
            return '佰';
        case 5:
            return '仟';
        case 6:
            return '万';
        case 7:
            return '拾';
        case 8:
            return '佰';
        case 9:
            return '仟';
        case 10:
            return '亿';
    }
}

function repace_acc(Money) {
    Money = Money.replace('零分', '');
    Money = Money.replace('零角', '零');
    let yy;
    let outmoney;
    outmoney = Money;
    yy = 0;
    /* eslint-disable */
    while (true) {
        let lett = outmoney.length;
        outmoney = outmoney.replace('零元', '元');
        outmoney = outmoney.replace('零万', '万');
        outmoney = outmoney.replace('零亿', '亿');
        outmoney = outmoney.replace('零仟', '零');
        outmoney = outmoney.replace('零佰', '零');
        outmoney = outmoney.replace('零零', '零');
        outmoney = outmoney.replace('零拾', '零');
        outmoney = outmoney.replace('亿万', '亿零');
        outmoney = outmoney.replace('万仟', '万零');
        outmoney = outmoney.replace('仟佰', '仟零');
        yy = outmoney.length;
        if (yy == lett) {
            break;
        }
    }
    yy = outmoney.length;
    if (outmoney.charAt(yy - 1) == '零') {
        outmoney = outmoney.substring(0, yy - 1);
    }
    yy = outmoney.length;
    if (outmoney.charAt(yy - 1) == '元') {
        outmoney = outmoney + '整';
    }
    return outmoney;
}
// 将base64转换为blob
function dataURLtoBlob(dataurl) {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}

function getUrlBase64(url) {
    return new Promise(resolve => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let img = new Image();
        img.crossOrigin = 'Anonymous'; //允许跨域
        img.src = url;
        img.onload = function () {
            canvas.height = 300;
            canvas.width = 300;
            ctx.drawImage(img, 0, 0, 300, 300);
            let dataURL = canvas.toDataURL('image/png');
            canvas = null;
            resolve(dataURL);
        };
    });
}

// 获取系统配置
function getSysConfig(Code) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetEntpSysConfigValueByCode',
            data: {
                Code: Code
            },
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}
//codes是数组
function getSysConfigs(codes) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpInfoManagement/GetEntpSysConfigValueByCodes',
            data: {
                Codes: codes
            },
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

function getUnionConfig(Code) {
    let currentUnion = getLocalStorage('currentUnion');
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpUnions/GetUnionConfigValueByCode',
            data: {
                UnionId: currentUnion,
                Code: Code
            }
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

function getUnionConfigs(codes) {
    let currentUnion = getLocalStorage('currentUnion');
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpUnions/GetUnionConfigValueByCodes',
            data: {
                UnionId: currentUnion,
                Codes: codes
            },
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

// 设置系统权限值
function setSysConfigValue(Id, RValue) {
    axiosPost({
        url: '/api/EntpInfoManagement/UpdateSysConfigResultsById',
        data: {
            EntpId: getLocalStorage('userMsg').EntpId,
            ConfigId: Id,
            RValue: RValue
        }
    })
        .then(() => {})
        .catch(() => {});
}
//获取员工数据
//noDismiss：过滤离职人员
function getSIdList(noDismiss = true) {
    return new Promise(resolve => {
        let _sIdList = getLocalStorage('sIdList');
        if (_sIdList && _sIdList.length > 0) {
            if (noDismiss) resolve(_sIdList.filter(s => !s.IsDismiss));
            else resolve(_sIdList);
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpStaffList'
            })
                .then(res => {
                    if (res.data) {
                        setLocalStorage('sIdList', res.data);
                        if (noDismiss) resolve(res.data.filter(s => !s.IsDismiss));
                        else resolve(res.data);
                    }
                })
                .catch(() => {});
        }
    });
}
//获取部门下的员工数据
function getSIdListByOrg(orgId) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetEntpStaffListByOrg',
            data: {
                OrgId: orgId
            }
        })
            .then(res => {
                if (res.data) {
                    resolve(res.data);
                }
            })
            .catch(() => {});
    });
}
// 获取员工数据
function getAuthSIdList() {
    return new Promise(resolve => {
        let _authSIdList = getLocalStorage('authSIdList');
        if (_authSIdList && _authSIdList.length > 0) {
            resolve(_authSIdList);
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpAuthStaffList'
            })
                .then(res => {
                    if (res.data) {
                        setLocalStorage('authSIdList', res.data);
                        resolve(res.data);
                    }
                })
                .catch(() => {});
        }
    });
}
// 获取员工数据 -- 统一处理员工数据请求
function getCommonSIdList() {
    return new Promise(resolve => {
        getSysConfig('sjqx').then(res => {
            let data = [];
            if (res.Result) {
                data = getAuthSIdList();
            } else {
                data = getSIdList();
            }
            resolve(data);
        });
    });
}
//新的支付方式
function getPay(key = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetAttrs?attrCode=paytype'
        })
            .then(res => {
                if (res.data) {
                    setLocalStorage('paytype', res.data);
                    let payWayList = res.data;
                    if (key == 1) {
                        payWayList = payWayList.filter(t => !t.IsSpecial && !t.IsSecSpecial);
                    }
                    resolve(payWayList);
                }
            })
            .catch(() => {});
    });
}
// 获取销售员工数据（过滤了没有销售过的人员）
function getSalemanList() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/DataStatistics/GetSalemans'
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}
// 获取销售员工数据（过滤了没有销售过的人员并且带权限）
function getSalemanListByAuth() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/DataStatistics/GetSalemansByAuth'
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}
// 获取采购员工数据（过滤了没有采购过的人员）
function getPurchaserList() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/DataStatistics/GetPurchaser'
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

function getUnionRoleList(key, page = 1, limit = 10) {
    let currentUnion = getLocalStorage('currentUnion');
    if (currentUnion) {
        return new Promise(resolve => {
            axiosGet({
                url: '/api/EntpUnions/GetUnionRoleList',
                data: {
                    RoleName: key,
                    page,
                    limit,
                    UnionId: currentUnion
                },
                hideLoading: true
            }).then(res => {
                resolve(res.data);
            });
        });
    }
}
function getRoleList(key, page = 1, limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetRoleList',
            data: {
                key: key,
                page,
                limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取订单来源
function getOrderSource() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpSaleOrder/GetOrderSources',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取订单来源,开启销售订单配置后使用，包括系统默认和客户自定义类型
function getSalesOrderSources() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpSaleOrder/GetSalesOrderSources',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取采购转化类型
function getPurOrderSource() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpPurchaseOrder/GetPurOrderSources',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取采购来源
function getPurOrderSetSources() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpPurchaseOrder/GetPurOrderSetSources',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取仓库数据（包含有类型）
function getWarehouse(key = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpWarehouse/GetWarehouseAuthList',
            data: {
                Type: key
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
function getWarehouseNotAuth(key = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpWarehouse/GetEntpWarehouseList',
            data: {
                Type: key
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//根据商品获取仓库
function getWarehouseByGId(goodsId, mustIn = true, type = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpWarehouse/GetWarehouseListByGId',
            data: {
                GoodsId: goodsId,
                Type: type,
                MustIn: mustIn
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//根据商品获取仓位
function getPositionByGId(params) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpShelfSpaces/GetShelfSpacesListByGoodsId',
            data: params,
            hideLoading: true
        }).then(res => {
            resolve(res);
        });
    });
}
//获取仓位列表
function GetShelfSpacesList(params) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpShelfSpaces/GetShelfSpacesList',
            data: params,
            hideLoading: true
        }).then(res => {
            resolve(res);
        });
    });
}

//获取仓位列表
function GetStdShelfSpacesList(params) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpShelfSpaces/GetStdShelfSpacesList',
            data: params,
            hideLoading: true
        }).then(res => {
            resolve(res);
        });
    });
}

function GetSSListForPurIn(params) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpShelfSpaces/GetSSListForPurIn',
            data: params,
            hideLoading: true
        }).then(res => {
            resolve(res);
        });
    });
}
//统计 只有在真实生产环境才进行统计
function fnStatistics() {
    if (
        process.env.NODE_ENV === 'production' &&
        window.location.href.indexOf('dev') == -1 &&
        window.location.href.indexOf('192.168') == -1 &&
        window.location.href.indexOf('localhost') == -1
    ) {
        let id = '__chehuijia__tongji__';
        let tongji = document.getElementById(id);
        if (tongji) {
            tongji.parentNode.removeChild(tongji);
        }

        let _userMsg = getLocalStorage('userMsg');
        let hm = document.createElement('script');
        let dsid = document.createAttribute('data-sid');
        let deid = document.createAttribute('data-eid');
        dsid.value = '0'; //system id
        deid.value = _userMsg ? _userMsg.EmployeeId : ''; //登录人Id
        hm.setAttributeNode(dsid);
        hm.setAttributeNode(deid);
        hm.src = 'http://hm.chehuijia.com.cn/frontend/hm.js?rnd=' + Math.random();
        hm.id = id;
        let s = document.getElementsByTagName('title')[0];
        s.parentNode.insertBefore(hm, s);
    }
}

function getCusPriceLevels() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpCustomers/GetCusPriceLevels',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchCustomer(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpCustomers/GetEntpCusListForSearch',
            data: {
                EntpCusName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchCustomerForEC(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpCustomers/GetEntpCusListForECSearch',
            data: {
                EntpCusName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchUnionMember(key, Page = 1, Limit = 10) {
    let currentUnion = getLocalStorage('currentUnion');
    if (currentUnion) {
        return new Promise(resolve => {
            axiosGet({
                url: '/api/EntpUnions/GetUnionMemberList',
                data: {
                    UnionId: currentUnion,
                    EntpName: key,
                    Page,
                    Limit
                },
                hideLoading: true
            }).then(res => {
                resolve(res.data);
            });
        });
    }
}

function searchUnions(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpUnions/GetUnionListForSearch',
            data: {
                UnionName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchCustomerNoAuth(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpCustomers/GetEntpCusListNoAuthForSearch',
            data: {
                EntpCusName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchSupplier(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpSuppliers/GetEntpSupListForSearch',
            data: {
                EntpCusName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchSupplierNoAuth(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpSuppliers/GetEntpSupListNoAuthForSearch',
            data: {
                EntpCusName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchCustomerAndSupplier(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/RevenueManagement/GetCusAndSupList',
            data: {
                EntpCusName: key,
                Page,
                Limit,
                EntpId: getLocalStorage('userMsg').EntpId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索物流公司
function searchLogistic(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpCustomers/GetEntpLCListForSearch',
            data: {
                Name: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchPurOrderSources(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpPurchaseOrder/GetPurchaseOrderSources',
            data: {
                Name: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

//获取采购订单来源数据
function searchPurchaseOrderSourceList(key) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/RevenueManagement/GetPurchaseOrderSourceList',
            data: {
                EntpCusName: key,
                Limit: 10,
                EntpId: getLocalStorage('userMsg').EntpId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function searchVINHis(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetVinSearchHisList',
            data: {
                VIN: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res);
        });
    });
}

//搜索车主
function searchCarOwners(key, page = 1, limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/CustomerManagement/SearchCarOwners',
            data: {
                name: key,
                page,
                limit,
                entpId: getLocalStorage('userMsg').EntpId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

// 获取未读条数
function getNoReadMsgCount() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/Notification/GetUnreadNoticCount',
            data: {
                UId: getLocalStorage('userMsg').EmployeeId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//新的发货方式
function getSendWay() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetAttrs?attrCode=deliverytype',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取单个商品的数据
function getEnterprisePart(goodsId) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEnterprisePart',
            data: {
                EntpTempGoodsId: goodsId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索商品品牌
function searchGoodsBrand() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEnterprisePartBrandList',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索商品分类
function searchGoodsType() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEntpPartCateList',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索商品回收站的商品分类
function searchDelGoodsType() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEntpPartCateListForDel',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索商品单位
function searchGoodsUnit() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEntpPartUnitList',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
function getEntpApCategoryList(key, page, limit) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetEntpApCateList',
            data: {
                name: key,
                page: page,
                limit: limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//搜索商品车型
function searchAutoSerie(key, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetVehicleSeriesList',
            data: {
                SeriesName: key,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取用户打印组件
function getPrintComponents(type) {
    let ty = 0;
    if (type) ty = type;
    return new Promise(resolve => {
        let pmodels = getLocalStorage('pmodels');
        if (pmodels) {
            let models = pmodels.filter(f => f.OrderType == ty);
            if (models && models.length > 0) {
                resolve(models[0].ModelCode);
            } else {
                axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpPrintModel',
                    data: {
                        type: ty
                    },
                    hideLoading: true
                })
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(() => {});
            }
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpPrintModel',
                data: {
                    type: ty
                },
                hideLoading: true
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(() => {});
        }
    });
}

function getEntpAllPrintModels(isCache) {
    return new Promise(resolve => {
        if (isCache) {
            let pmodels = getLocalStorage('pmodels');
            if (!pmodels) {
                axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpAllPrintModels',
                    data: {
                        isCache: isCache
                    },
                    hideLoading: true
                })
                    .then(res => {
                        setLocalStorage('pmodels', res.data);
                        resolve(res.data);
                    })
                    .catch(() => {});
            }
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpAllPrintModels',
                data: {
                    isCache: isCache
                },
                hideLoading: true
            })
                .then(res => {
                    setLocalStorage('pmodels', res.data);
                    resolve(res.data);
                })
                .catch(() => {});
        }
    });
}

// 获取列表页码，需返回一个Number值
function getPageLimit() {
    return new Promise(resolve => {
        let _pagesetlimit = getLocalStorage('p_limit');
        if (_pagesetlimit) {
            resolve(Number(_pagesetlimit));
        } else {
            getSysConfig('pagesetlimit').then(res => {
                if (res.Result) {
                    setLocalStorage('p_limit', Number(res.RValue));
                    resolve(Number(res.RValue));
                } else resolve(15);
            });
        }
    });
}

let tbs = 0;
function getTableSetsData(tableCode) {
    return new Promise(resolve => {
        let _tableSets = getLocalStorage('ts_temp_' + tableCode);
        if (tbs == 0) {
            tbs += 1;
            if (_tableSets) {
                resolve(_tableSets);
            } else {
                axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpStaffTableSets',
                    data: {
                        tableCode: tableCode
                    },
                    hideLoading: true
                })
                    .then(res => {
                        setLocalStorage('ts_temp_' + tableCode, res.data);
                        tbs = 0;
                        resolve(res.data);
                    })
                    .catch(res => {
                        tbs = 0;
                        resolve(res);
                    });
            }
        } else {
            if (!_tableSets) {
                sleep(1500).then(() => {
                    axiosGet({
                        url: '/api/EntpInfoManagement/GetEntpStaffTableSets',
                        data: {
                            tableCode: tableCode
                        },
                        hideLoading: true
                    })
                        .then(res => {
                            setLocalStorage('ts_temp_' + tableCode, res.data);
                            tbs = 0;
                            resolve(res.data);
                        })
                        .catch(res => {
                            tbs = 0;
                            resolve(res);
                        });
                });
            } else resolve(_tableSets);
        }
    });
}

function getTBSetsForShow(tableCode) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetStaffTBSetsForShow',
            data: {
                tableCode: tableCode
            },
            hideLoading: true
        })
            .then(res => {
                setLocalStorage('ts_' + tableCode, res.data);
                resolve(res.data);
            })
            .catch(res => {
                let _tableSets = getLocalStorage('ts_' + tableCode);
                if (_tableSets) resolve(_tableSets);
            });
    });
}

function getSearchCrtSetsData(tableCode, isCache) {
    return new Promise(resolve => {
        let _searchSets = getLocalStorage('ss_' + tableCode);
        if (_searchSets && isCache) {
            resolve(_searchSets);
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpStaffSearchCriteriaSets',
                data: {
                    tableCode: tableCode
                },
                hideLoading: true
            }).then(res => {
                setLocalStorage('ss_' + tableCode, res.data);
                resolve(res.data);
            });
        }
    });
}

function getJointSearchSetsData(isCache) {
    return new Promise(resolve => {
        let _gsSets = getLocalStorage('js_goods');
        if (_gsSets && isCache) {
            resolve(_gsSets);
        } else {
            axiosGet({
                url: '/api/EntpInfoManagement/GetEntpStaffJointSearchSets',
                hideLoading: true
            }).then(res => {
                setLocalStorage('js_goods', res.data);
                resolve(res.data);
            });
        }
    });
}

function refresh() {
    window.location.reload();
}

//验证一张单是否有多天出入库
function VerOrderInOutRecords(orderId) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpWarehouse/VerOrderInOutRecords',
            data: {
                OrderId: orderId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}

function getGoodsDataAfterSelItem(GoodsId, SId, CId, Source = '0', IsIntentShow = false) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetGoodsDataAfterSelItem',
            data: {
                GoodsId: GoodsId,
                SId: SId,
                CId: CId,
                Source: Source,
                IsIntentShow: IsIntentShow
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//IsMPrice:是否默认价格零售价
function getGoodsDataForConfirm_V3(GoodsId, SId, CId, Source = '0', IsMPrice = false, MPrice = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetGoodsDataForConfirm_V3',
            data: {
                GoodsId: GoodsId,
                SId: SId,
                CId: CId,
                Source: Source,
                IsMPrice: IsMPrice,
                MPrice: MPrice
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//睡眠函数
function sleep(millis) {
    return new Promise(resolve => {
        setInterval(() => {
            resolve();
        }, millis);
    });
}
//获取父级组织
function getParentOrgs(key = 0) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetParentOrgs',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//添加打印记录
function printedRecord(req, hideLoading = false) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpSaleOrder/PrintedRecord',
            data: req,
            hideLoading: hideLoading
        })
            .then(res => {
                resolve(res);
            })
            .catch(() => {});
    });
}
function searchPartAttr(key, type, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetParAttrByKey',
            data: {
                key,
                type,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
function searchUnionPartAttr(key, type, Page = 1, Limit = 10) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpUnionGoods/GetUnionParAttrByKey',
            data: {
                unionId: getLocalStorage('currentUnion'),
                key,
                type,
                Page,
                Limit
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
function debounce(func, wait = 250, immediate = false) {
    //func函数，wait为时间周期
    let timeout;
    return new Promise(resolve => {
        let context = this,
            args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
        resolve();
    });
}
function md5(str) {
    return new Promise(resolve => {
        let md5 = MD5.hex_md5(str); //必须是字符串
        resolve(md5);
    });
}
function getPerfSets() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetPerfSetsForSelect',
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}
function getCoProjects() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetCoProjects',
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

function getAuthCoProjects() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetAuthCoProjects',
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

function getECPackSizeSetList() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetECPackSizeSetList',
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}

// 获取企业缓存
function GetEntpCache(req, hideLoading = true) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpSaleOrder/GetEntpCache',
            data: req,
            hideLoading: hideLoading
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(() => {});
    });
}
// 设置企业缓存
function SetEntpCache(req, hideLoading = true) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpSaleOrder/SetEntpCache',
            data: { CacheList: req },
            hideLoading: hideLoading
        })
            .then(res => {
                resolve(res);
            })
            .catch(() => {});
    });
}
//获取拜访类型
function getTasksType() {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetAttrs?attrCode=tasksType',
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取车型的接口
function getAutoSeriesByBFL(param) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpGoods/GetAutoSeriesByBFL',
            data: param,
            hideLoading: true
        })
            .then(res => {
                let data = res.data;
                if (data != null) {
                    resolve(data);
                }
            })
            .catch(() => {});
    });
}
//上传开始
function uploadStartRecords(req) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpInfoManagement/UploadStartRecords',
            data: req,
            hideLoading: true
        })
            .then(res => {
                resolve(res);
            })
            .catch(() => {});
    });
}
//上传结束
function uploadEndRecords(req) {
    return new Promise(resolve => {
        axiosPost({
            url: '/api/EntpInfoManagement/UploadEndRecords',
            data: req,
            hideLoading: true
        })
            .then(res => {
                resolve(res);
            })
            .catch(() => {});
    });
}
//获取商品三个月内最低价供应商
function getGoodsLatestPur(goodsId) {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpPurchaseOrder/GetGoodsLatestPur',
            data: {
                goodsId: goodsId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
//获取企业电商平台的店铺数据
function getPlatformShops(platformId = '') {
    return new Promise(resolve => {
        axiosGet({
            url: '/api/EntpInfoManagement/GetEntpPlatformShops',
            data: {
                platformId: platformId
            },
            hideLoading: true
        }).then(res => {
            resolve(res.data);
        });
    });
}
export default {
    md5,
    debounce,
    setSysConfigValue,
    getSysConfig,
    uniqueArr,
    guid,
    confirmBeforeLeave,
    setEnterEvent,
    setEventForDialog,
    removeEventForDialog,
    getCookie,
    setCookie,
    clearCookie,
    // browseRecord,
    elConfirm,
    axiosGet,
    axiosPost,
    successMsg,
    warningMsg,
    errorMsg,
    setLocalStorage,
    getLocalStorage,
    clearLocalStorage,
    clearAllLocalStorage,
    setSessionStorage,
    getSessionStorage,
    clearSessionStorage,
    getNowFormatTime,
    getNowFormatDate,
    geToken,
    parseParam,
    uploadCheck,
    getConfigData,
    checkPhone,
    checkEmail,
    checkPositive,
    checkInt,
    checkAddress,
    clearValidate,
    buyAgain,
    getMessage,
    gotoMessageDetails,
    dateDifference,
    goodsJoinCar,
    suitJoinCar,
    num2Float,
    getOtherDay,
    deepCopy,
    getNode,
    getTree,
    getPermission,
    exportFile,
    exportFile_post,
    getAcrossNavNode,
    CHJWinApp,
    BASE_URL,
    QN_UPLOAD_URL,
    QN_URL_BASE,
    CHAT_BASE_URL,
    DEFAULT_IMAGE,
    DEFAULT_IMAGE_square,
    serverRoot,
    getSIdList,
    getSIdListByOrg,
    getPay,
    getSalemanList,
    getSalemanListByAuth,
    getPurchaserList,
    getUserIMData,
    fnStatistics,
    searchCustomer,
    searchCustomerForEC,
    searchSupplier,
    searchLogistic,
    searchCustomerAndSupplier,
    searchCarOwners,
    searchPurchaseOrderSourceList,
    getNoReadMsgCount,
    getSendWay,
    moneyToCapital,
    searchGoodsBrand,
    searchGoodsType,
    searchDelGoodsType,
    searchAutoSerie,
    dataURLtoBlob,
    getUrlBase64,
    getPrintComponents,
    getEntpAllPrintModels,
    updateRoot,
    getAuthSIdList,
    getWarehouse,
    getWarehouseByGId,
    getPositionByGId,
    GetShelfSpacesList,
    GetSSListForPurIn,
    searchCustomerNoAuth,
    getPageLimit,
    getTableSetsData,
    refresh,
    getSearchCrtSetsData,
    getJointSearchSetsData,
    getEntpApCategoryList,
    VerOrderInOutRecords,
    getHomeModules,
    getUnionDatas,
    searchUnions,
    getUnionTree,
    getAcrossUnionNavNode,
    getUnionPermission,
    getUnionNode,
    clearLoginedData,
    getGoodsDataAfterSelItem,
    updateUnionRoot,
    getUnionRoleList,
    getUnionConfig,
    searchUnionMember,
    formatDate,
    formatDateV2,
    formatDateV3,
    getSysConfigs,
    sleep,
    getParentOrgs,
    getGoodsDataForConfirm_V3,
    printedRecord,
    searchPartAttr,
    searchUnionPartAttr,
    searchGoodsUnit,
    getCommonSIdList,
    searchSupplierNoAuth,
    searchPurOrderSources,
    getWarehouseNotAuth,
    getTreeForDT,
    getTreeForTop,
    getEnterprisePart,
    getOrderSource,
    getSalesOrderSources,
    getPurOrderSetSources,
    getPurOrderSource,
    getCusPriceLevels,
    searchVINHis,
    getTBSetsForShow,
    getPerfSets,
    getCoProjects,
    getUnionConfigs,
    GetEntpCache,
    SetEntpCache,
    GetStdShelfSpacesList,
    getTasksType,
    getAuthCoProjects,
    getECPackSizeSetList,
    getAutoSeriesByBFL,
    validatePhoneNumber,
    validateMobileCountry,
    validateMobile,
    uploadStartRecords,
    uploadEndRecords,
    getGoodsLatestPur,
    getPlatformShops,
    getRoleList
};
